export const optionTypeAccess = [
  {
    value: 'NORTH',
    label: 'NORTH'
  },
  {
    value: 'CENTRAL_EAST',
    label: 'CENTRAL EAST'
  },
  {
    value: 'CENTRAL_WEST',
    label: 'CENTRAL WEST'
  },
  {
    value: 'SOUTH',
    label: 'SOUTH'
  }
];

export const dropdownValueTypes = {
  reportIssue: 'REPORT_ISSUE',
  asset: 'ASSET',
  roomLevelIssue: 'ROOM_LEVEL_ISSUE',
  room: 'ROOM',
  additionalStructure: 'ADDITIONAL_STRUCTURE',
  assetType: 'ASSET_TYPE',
  assetModel: 'ASSET_MODEL'
};

export const maintainanceName = 'Maintenance Frequency';
